export const appViewModeConstants = {
    ADMIN_MODE: 'Admin',
    VIEW_MODE: 'View'
};

export default appViewModeConstants;
